import {
  ExportDocumentResponse,
  ParsedExportContentJob,
  PrintExamInput,
  PrintPerformanceAssessmentInput,
  PrintVerificationDocumentInput,
  PrintYearAtaGlanceInput,
} from "@examspark/types";

import { GraphQLAPI } from "../client";
import * as jobs from "../queries/jobs";
import * as print from "../queries/print";

export const printExam = async (request: PrintExamInput) =>
  GraphQLAPI.query<{
    printExam: ExportDocumentResponse;
  }>({
    query: print.printExam(),
    variables: {
      input: request,
    },
  });

export const printVerificationDocument = async (
  request: PrintVerificationDocumentInput,
) =>
  GraphQLAPI.query<{
    printVerificationDocument: ExportDocumentResponse;
  }>({
    query: print.printVerificationDocument(),
    variables: { input: request },
  });

export const printYearAtAGlanceDocument = async (
  request: PrintYearAtaGlanceInput,
) =>
  GraphQLAPI.query<{
    printYearAtaGlance: ExportDocumentResponse;
  }>({
    query: print.printYearAtAGlanceDocument(),
    variables: { input: request },
  });

export const printPerformanceAssessmentDocument = async (
  request: PrintPerformanceAssessmentInput,
) =>
  GraphQLAPI.query<{
    printPerformanceAssessment: ExportDocumentResponse;
  }>({
    query: print.printPerformanceAssessmentDocument(),
    variables: { input: request },
  });

export const requestContentExport = async (request: ParsedExportContentJob) => {
  return GraphQLAPI.query<{ input: ParsedExportContentJob }>({
    query: jobs.createJob,
    variables: {
      input: request,
    },
  });
};
